import React from "react";

export const LoggedOutBanner = () => (
    <div className="offline-banner">
        You need to login
    </div>
);
